module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-xs-12 p-x-0 m-b-10 flex align-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.goBackInfo.name,
        params: _vm.goBackInfo.params,
        query: _vm.goBackInfo.query
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default m-r-5 flex"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex grey darken-1"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ? _vm.brand.name : _vm.store.brand_name ? _vm.store.brand_name : '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('cr-category')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c7319eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/UpMenuCategory.vue
// module id = 2386
// module chunks = 1